// extracted by mini-css-extract-plugin
module.exports = {"rtlContainer":"rtl_rtlContainer__1BLG3"};